import React from 'react';
import styled from 'styled-components'
import logo from './Assets/img/AF_WERFEN_BN_NEG_RGB.png'
import withSizes from 'react-sizes'
import packageJson from '../../../../../package.json';

/*
 *  @Description:   Stateless component that renders an Image, used as the company logo.
 */
const Wrapper = styled.div`
    position: relative;
    display: inline-block;
`;

const StyledLink = styled.a`
    position: relative; 
    display: inline-block;
	width: 100%;
	padding:0;
	margin: 0;
	box-sizing: content-box;
`;

const StyledImg = styled.img`
	position: relative;
    top: 0;
    display: block;
	width: 100%;
	padding:0;
	margin: 0;
`;

const Version = styled.span`
    position: absolute;
    bottom: 5px;
    right: 35px;
    font-size: 16px;
    font-weight: bold;
    color: #FFF;
`;

const mapSizesToProps = ( { width, height } ) => ({
    windowWidth: width,
    windowHeight: height,
});

const Logo = ( props ) => {
    return (
        <Wrapper>
            <StyledLink to="/">
                <StyledImg src={ logo } width={ props.windowWidth }/>
            </StyledLink>
            <Version>v{packageJson.version}</Version>
        </Wrapper>
    );
};

export default withSizes( mapSizesToProps )( Logo );
